import { render, staticRenderFns } from "./passDialog.vue?vue&type=template&id=2956388d&scoped=true"
import script from "./passDialog.vue?vue&type=script&lang=js"
export * from "./passDialog.vue?vue&type=script&lang=js"
import style0 from "./passDialog.vue?vue&type=style&index=0&id=2956388d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2956388d",
  null
  
)

export default component.exports